import * as v from 'valibot';

const nullableString = v.nullable(v.string());

// TODO: extend when API is defined
export const projectSummaryApiSchema = v.object({
  approvedBy: nullableString,
  description: v.string(),
  endDate: v.string(),
  isActive: v.boolean(),
  isApproved: v.boolean(),
  projectId: v.number(),
  projectName: v.string(),
  startDate: v.string(),
});

export const projectSummarySchema = v.object({
  ...projectSummaryApiSchema.entries,
});

export const projectsApiSchema = v.object({
  items: v.array(projectSummaryApiSchema),
  totalCount: v.number(),
});

export type ProjectSummaryApi = v.InferOutput<typeof projectSummaryApiSchema>;
export type ProjectSummary = v.InferOutput<typeof projectSummarySchema>;
export type ProjectsApi = v.InferOutput<typeof projectsApiSchema>;

// TODO: extend when API search params contract is defined
export const projectsSearchParamsSchema = v.object({
  skip: v.optional(v.number()),
  take: v.optional(v.number()),
});

export type ProjectsSearchParams = v.InferInput<typeof projectsSearchParamsSchema>;
